// src/constants/manufacturerMap.ts

export const manufacturerMap: Record<number, { name: string; logo: string }> = {
    
    0: { name: "NO_RESULT", logo: "placeholder" },
    1: { name: "Continental", logo: "placeholder" },
    2: { name: "Achilles", logo: "placeholder" },
    3: { name: "Bridgestone", logo: "placeholder" },
    4: { name: "Dunlop", logo: "placeholder" },
    5: { name: "Firestone", logo: "placeholder" },
    6: { name: "Fulda", logo: "placeholder" },
    7: { name: "Gerutti", logo: "placeholder" },
    8: { name: "GoodYear", logo: "placeholder" },
    9: { name: "Hankook", logo: "placeholder" },
    10: { name: "Landsail", logo: "placeholder" },
    11: { name: "Michelin", logo: "placeholder" },
    12: { name: "Nokian", logo: "placeholder" },
    13: { name: "Pirelli", logo: "placeholder" },
    14: { name: "Semperit", logo: "placeholder" },
    15: { name: "StarPerformer", logo: "placeholder" },
    16: { name: "Toyo", logo: "placeholder" },
    17: { name: "Barum", logo: "placeholder" },
    18: { name: "Falken", logo: "placeholder" },
    19: { name: "Kleber", logo: "placeholder" },
    20: { name: "Yokohama", logo: "placeholder" },
    21: { name: "Vredestein", logo: "placeholder" },
    22: { name: "Nexen", logo: "placeholder" },
    23: { name: "Milestone", logo: "placeholder" },
    24: { name: "UniRoyal", logo: "placeholder" },
    25: { name: "BFGoodrich", logo: "placeholder" },
    26: { name: "Matador", logo: "placeholder" },
    27: { name: "Tyfoon", logo: "placeholder" },
    28: { name: "Platin", logo: "placeholder" },
    29: { name: "Kumho", logo: "placeholder" },
    30: { name: "Minerva", logo: "placeholder" },
    31: { name: "Viking", logo: "placeholder" },
    32: { name: "Gislaved", logo: "placeholder" },
    33: { name: "Maxxis", logo: "placeholder" },
    34: { name: "Sava", logo: "placeholder" },
    35: { name: "Atlas", logo: "placeholder" },
    36: { name: "Lassa", logo: "placeholder" },
};
